(function(){
  /* ===== Config ===== */
  var LOG = false;                 // set true to debug
  var MAX_TRIES = 16;              // ~8–10s window with backoff
  var BASE_DELAY = 320, CAP_DELAY = 1200;
  var CREDIT_POLICY = 'last';      // 'last' (URL/_gl > cookie) or 'first' (cookie > URL/_gl)
  var SS_KEY = 'shopsta_click_signals_v2'; // sessionStorage cache
  var SS_LANDING_KEY = 'shopsta_landing_logged'; // track if landing already logged

  /* ===== Helpers (ES5) ===== */
  function log(){ if(LOG && window.console && console.log) try{ console.log.apply(console, arguments);}catch(_){ console.log(arguments);} }
  function qpFrom(str, key){
    try { return new URLSearchParams(str.replace(/^[^?]*\?/, '')).get(key) || ""; } catch(e){ return ""; }
  }
  function qp(key){ return qpFrom(location.search, key); }
  function cookie(name){ var m=document.cookie.match('(?:^|; )'+name+'=([^;]*)'); return m?decodeURIComponent(m[1]):""; }
  // Helper to check if value exists and is not empty
  function hasValue(v){ return v !== undefined && v !== null && v !== ""; }
  function nextDelay(i){ var d=Math.min(CAP_DELAY, BASE_DELAY*Math.pow(1.6,i)); return d + Math.floor(Math.random()*80); }

  // Robust base64 decode (handles URL-safe, missing padding, stray periods)
  function b64decode(s){
    if(!s) return "";
    try{
      s = s.replace(/\./g,'');           // linker may end with '..'
      s = s.replace(/-/g,'+').replace(/_/g,'/'); // URL-safe to std
      while (s.length % 4) s += '=';     // pad
      return atob(s);
    }catch(e){ return ""; }
  }

  // Parse GCLID from _gl param (decode the _gcl_aw* base64 payload -> "GCL.<ts>.<gclid>")
  function gclidFromGlStr(glStr){
    if(!glStr) return "";
    try{
      var dec = decodeURIComponent(glStr);
      var m = dec.match(/_gcl_aw\*([^*]+)/i);
      if(!m || !m[1]) return "";
      var decoded = b64decode(m[1]);
      // Expect "GCL.<timestamp>.<gclid>"
      var parts = decoded.split('.');
      if (parts.length >= 3 && parts[0] === 'GCL') {
        // join any extra trailing segments back (defensive)
        return parts.slice(2).join('.');
      }
      // Some variants embed "gclid=<...>"
      var mg = decoded.match(/gclid=([^&]+)/i);
      return mg ? mg[1] : "";
    }catch(e){ return ""; }
  }

  // Parse GCLID from cookies: supports "GCL.<ts>.<gclid>" and "gclid=<gclid>"
  function gclidFromCookies(){
    var v = cookie('_gcl_aw') || cookie('_gcl_dc');
    if(!v) return "";
    // pattern 1: "GCL.<ts>.<gclid>"
    var p = v.split('.');
    if (p.length >= 3 && p[0] === 'GCL') return p.slice(2).join('.');
    // pattern 2: "...gclid=<gclid>..."
    var mg = v.match(/gclid=([^;|]+)/i);
    return mg ? mg[1] : "";
  }

  function currentSignals(){
    var url_gclid = qp('gclid');
    var url_msclkid = qp('msclkid'); // Microsoft Ads
    var url_fbclid = qp('fbclid'); // Facebook Ads
    var url_gl    = qp('_gl') || qp('?_gl'); // tolerant
    var ref = document.referrer || "";
    var ref_gclid = ref ? qpFrom(ref, 'gclid') : "";
    var ref_msclkid = ref ? qpFrom(ref, 'msclkid') : "";
    var ref_fbclid = ref ? qpFrom(ref, 'fbclid') : "";
    var ref_gl    = ref ? qpFrom(ref, '_gl')   : "";
    var from_url  = url_gclid || gclidFromGlStr(url_gl);
    var from_ref  = ref_gclid || gclidFromGlStr(ref_gl);
    var cookie_g  = gclidFromCookies();

    // Session cache
    var cached = {};
    try{ cached = JSON.parse(sessionStorage.getItem(SS_KEY) || '{}'); }catch(_){ cached = {}; }

    // Choose precedence for gclid
    var chosen = CREDIT_POLICY==='first'
      ? (cookie_g || from_url || from_ref || cached.gclid || "")
      : (from_url || from_ref || cookie_g || cached.gclid || "");

    // Choose precedence for msclkid and fbclid (URL > referrer > cached)
    var chosen_msclkid = url_msclkid || ref_msclkid || cached.msclkid || "";
    var chosen_fbclid = url_fbclid || ref_fbclid || cached.fbclid || "";

    // braids
    var url_gbraid = qp('gbraid') || (ref ? qpFrom(ref,'gbraid') : "") || (cached.gbraid || "");
    var url_wbraid = qp('wbraid') || (ref ? qpFrom(ref,'wbraid') : "") || (cached.wbraid || "");

    return {
      chosen_gclid: chosen || "",
      chosen_msclkid: chosen_msclkid || "",
      chosen_fbclid: chosen_fbclid || "",
      url_gclid: url_gclid || "",
      url_gl: url_gl || "",
      ref_gclid: ref_gclid || "",
      ref_gl: ref_gl || "",
      cookie_gclid: cookie_g || "",
      gbraid: url_gbraid || "",
      wbraid: url_wbraid || ""
    };
  }

  function saveToSession(g, gb, wb, ms, fb){
    try{
      var prev = {}; try{ prev = JSON.parse(sessionStorage.getItem(SS_KEY) || '{}'); }catch(_){}
      if (g)  prev.gclid  = g;
      if (gb) prev.gbraid = gb;
      if (wb) prev.wbraid = wb;
      if (ms) prev.msclkid = ms;
      if (fb) prev.fbclid = fb;
      sessionStorage.setItem(SS_KEY, JSON.stringify(prev));
    }catch(_){}
  }

  function hasLandingBeenLogged(){
    try{ return sessionStorage.getItem(SS_LANDING_KEY) === 'true'; }catch(_){ return false; }
  }
  function markLandingAsLogged(){
    try{ sessionStorage.setItem(SS_LANDING_KEY, 'true'); }catch(_){}
  }

  function root(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function path(p){ return root().replace(/\/?$/,'/') + p.replace(/^\//,''); }
  var CART   = path('cart.js');
  var UPDATE = path('cart/update.js');

  function fetchJSON(url, opts){
    opts = opts || {}; opts.credentials = 'same-origin'; opts.keepalive = true;
    return fetch(url, opts).then(function(r){ var s=r.status; return r.json().then(function(j){ return {ok:r.ok,status:s,json:j}; }); });
  }
  function getCart(cb){ fetchJSON(CART,{cache:'no-store'}).then(function(res){ cb(null,res.json); }).catch(function(e){ cb(e); }); }
  function needsUpdate(current, wanted){
    if (!current) return true;
    for (var k in wanted){ if (wanted.hasOwnProperty(k) && current[k] !== wanted[k]) return true; }
    return false;
  }

  if (/^\/checkout/.test(location.pathname)) return;

  /* ===== Protected quick write (first page load only) ===== */
  (function quickWrite(){
    // Only run if landing hasn't been logged yet
    if (hasLandingBeenLogged()) return;
    
    try{
      var sig = currentSignals();
      
      // Mark immediately to prevent subsequent pages from overwriting
      markLandingAsLogged();
      
      // Cache signals for later pages
      saveToSession(sig.chosen_gclid, sig.gbraid, sig.wbraid, sig.chosen_msclkid, sig.chosen_fbclid);
      
      var quickData = { ran: "yes" };
      
      // Only write values that exist
      if (location.href) quickData.landing_url = location.href;
      if (document.referrer) quickData.landing_referrer = document.referrer;
      if (location.search) quickData.raw_search = location.search;
      var refSearch = (document.referrer || "").split('?')[1];
      if (refSearch) quickData.raw_ref_search = '?' + refSearch;
      
      if (sig.chosen_gclid) {
        quickData.gclid_first = sig.chosen_gclid;
        quickData.gclid_last = sig.chosen_gclid;
      }
      if (sig.chosen_msclkid) {
        quickData.msclkid_first = sig.chosen_msclkid;
        quickData.msclkid_last = sig.chosen_msclkid;
      }
      if (sig.chosen_fbclid) {
        quickData.fbclid_first = sig.chosen_fbclid;
        quickData.fbclid_last = sig.chosen_fbclid;
      }
      if (sig.gbraid) quickData.gbraid = sig.gbraid;
      if (sig.wbraid) quickData.wbraid = sig.wbraid;
      
      fetchJSON(UPDATE, {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ attributes: quickData })
      }).catch(function(){});
    }catch(_){}
  })();

  /* ===== Main writer with verify + backoff ===== */
  var attempts = 0, inFlight = false;

  function desiredAttributes(cartAttrs, sig){
    // cache what we found for later pages
    saveToSession(sig.chosen_gclid, sig.gbraid, sig.wbraid, sig.chosen_msclkid, sig.chosen_fbclid);

    var a = cartAttrs || {};
    // first/last logic for gclid
    var g_first = hasValue(a.gclid_first) ? a.gclid_first : sig.chosen_gclid;
    var g_last  = sig.chosen_gclid || a.gclid_last;

    // first/last logic for msclkid
    var ms_first = hasValue(a.msclkid_first) ? a.msclkid_first : sig.chosen_msclkid;
    var ms_last  = sig.chosen_msclkid || a.msclkid_last;

    // first/last logic for fbclid
    var fb_first = hasValue(a.fbclid_first) ? a.fbclid_first : sig.chosen_fbclid;
    var fb_last  = sig.chosen_fbclid || a.fbclid_last;

    // Only set landing_url and landing_referrer if BOTH session flag AND cart attributes are set
    // This makes the system self-healing: if quick write failed, smart write will capture it
    var landingAlreadyLogged = hasLandingBeenLogged() && hasValue(a.landing_url);
    var landing_url = landingAlreadyLogged ? a.landing_url : location.href;
    var landing_referrer = landingAlreadyLogged ? a.landing_referrer : (document.referrer || "");
    
    // Mark as logged if we're setting it for the first time
    if (!landingAlreadyLogged) markLandingAsLogged();

    var result = { ran: "yes" };
    
    // Only write values that exist
    if (landing_url) result.landing_url = landing_url;
    if (landing_referrer) result.landing_referrer = landing_referrer;
    if (location.search) result.raw_search = location.search;
    var refSearch = (document.referrer || "").split('?')[1];
    if (refSearch) result.raw_ref_search = '?' + refSearch;
    
    if (g_first) result.gclid_first = g_first;
    if (g_last) result.gclid_last = g_last;
    if (ms_first) result.msclkid_first = ms_first;
    if (ms_last) result.msclkid_last = ms_last;
    if (fb_first) result.fbclid_first = fb_first;
    if (fb_last) result.fbclid_last = fb_last;
    if (sig.gbraid) result.gbraid = sig.gbraid;
    if (sig.wbraid) result.wbraid = sig.wbraid;
    
    return result;
  }

  function tick(){
    if (inFlight) return;
    inFlight = true;

    var sig = currentSignals();
    log('[conv] signals:', sig);

    getCart(function(err, cart){
      if (err){ inFlight=false; if (attempts<MAX_TRIES){ attempts++; setTimeout(tick, nextDelay(attempts)); } return; }

      var a = (cart && cart.attributes) || {};
      var want = desiredAttributes(a, sig);

      if (!needsUpdate(a, want)){
        inFlight=false;
        return;
      }

      fetchJSON(UPDATE, {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ attributes: want })
      })
      .then(function(){
        // Normalize LAST to cookie GCLID when cookie appears (canonical CjwK/EAIa value)
        var cookieG = gclidFromCookies();
        if (cookieG && cookieG !== (a.gclid_last || sig.chosen_gclid || "")) {
          saveToSession(cookieG);
          return fetchJSON(UPDATE, {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body: JSON.stringify({ attributes: { gclid_last: cookieG, ran: "yes" } })
          });
        }
      })
      .then(function(){
        // Verify; retry if still not applied
        getCart(function(e2, c2){
          inFlight=false;
          if (needsUpdate(c2 && c2.attributes, want) && attempts<MAX_TRIES){
            attempts++; setTimeout(tick, nextDelay(attempts));
          }
        });
      })
      .catch(function(){
        inFlight=false;
        if (attempts<MAX_TRIES){ attempts++; setTimeout(tick, nextDelay(attempts)); }
      });
    });
  }

  /* ===== Triggers to maximize coverage ===== */
  if (document.readyState === 'loading'){
    setTimeout(tick, 0);
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(tick, 0); });
  } else {
    setTimeout(tick, 0);
  }

  // After add-to-cart (HTML forms)
  document.addEventListener('submit', function(e){
    try{ var f=e.target; if(!f||!f.action) return; if(f.action.indexOf('/cart/add')===-1) return; setTimeout(tick, 200); }catch(_){}
  }, true);

  // After AJAX cart updates (fetch)
  (function(){
    if (!window.fetch) return;
    var orig=window.fetch;
    window.fetch=function(){
      try{
        var u=(arguments[0]&&arguments[0].url)||arguments[0]||'';
        if (typeof u==='string' && (/\/cart\/(add|update)\.js/).test(u)) setTimeout(tick, 200);
      }catch(_){}
      return orig.apply(this, arguments);
    };
  })();

  // After AJAX cart updates (XHR)
  (function(){
    var X=window.XMLHttpRequest; if(!X) return;
    var open=X.prototype.open, send=X.prototype.send;
    X.prototype.open=function(method,url){
      this.__isCartReq=(typeof url==='string' && (/\/cart\/(add|update)\.js/).test(url));
      return open.apply(this, arguments);
    };
    X.prototype.send=function(){
      if(this.__isCartReq){
        try{ this.addEventListener('load', function(){ setTimeout(tick, 200); }); }catch(_){}
      }
      return send.apply(this, arguments);
    };
  })();

  // Express checkout buttons (Shop Pay, Apple Pay, Google Pay) - safety net for fast clickers
  document.addEventListener('shopify:payment_button:clicked', function(){ setTimeout(tick, 80); });
  document.addEventListener('shopify:payment_button_tapped', function(){ setTimeout(tick, 80); });

})();